// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"i0-z"};